<template>
    <div class="mt-2">

        <v-container>
            <v-layout row wrap class="justify-space-around">
                <v-flex xs12 sm12 md9>
                    <v-card class="mx-2">
                        <v-card-text>
                            <h1>Stage de récupération de points obligatoire en permis probatoire</h1>

                            <p>Tous les jeunes conducteurs ayant réussi l’examen du permis de conduire entrent dans une
                                période probatoire. Sa durée varie selon la méthode d’apprentissage suivie :</p>

                            <ul>
                                <li>3 ans pour l’apprentissage traditionnel.</li>
                                <li>2 ans pour la conduite accompagnée.</li>
                            </ul>

                            <p>Le capital de départ du permis de conduire est de 6 points. En l’absence d’infraction
                                durant toute la période probatoire, le permis de conduire est crédité à 12 points à son
                                issue.</p>

                            <p>L’obtention des points est bloquée si une infraction au Code la Route est commise par le
                                jeune conducteur pendant sa période probatoire. Toute infraction sanctionnée par au
                                moins 3 points oblige le jeune conducteur détenteur d’un permis probatoire à suivre un
                                stage de récupération de points au sein d’un centre agréé.</p>

                            <div class="mb-2">
                                <h2>Réception de la lettre 48N suite à la perte d’au moins 3 points </h2>

                                <p>La verbalisation de certaines infractions comme un excès de vitesse supérieur à
                                    30km/h,
                                    l’usage du téléphone au volant ou le non-respect d’un feu rouge entraîne comme
                                    sanction
                                    la
                                    perte d’au moins 3 points. Le détenteur du permis probatoire reçoit alors la lettre
                                    48N
                                    qui
                                    est un courrier recommandé envoyé par le Ministère de l’Intérieur.</p>

                                <p>La lettre 48N indique que le jeune conducteur doit obligatoirement suivre un stage de
                                    sensibilisation de la sécurité routière dans les 4 mois suivant la réception du
                                    courrier.
                                    Elle informe aussi du retrait effectif des points.</p>

                                <p>En participant au stage obligatoire en permis probatoire, le conducteur peut
                                    récupérer
                                    jusqu’à 4 points, dans la limite du capital points. Selon l’année d’ancienneté, ce
                                    capital
                                    peut être de 6, 8 ou 10 points.</p>
                                <p>Il n’est possible de récupérer quatre points qu’une seule fois par an.</p>

                                <h2>L’inscription à un stage obligatoire en période probatoire</h2>

                                <p>Pendant le stage obligatoire en période probatoire, les jeunes conducteurs sont
                                    sensibilisés
                                    aux dangers de la route. Il s’agit d’une éducation routière différente de celle de
                                    l’auto-école. En effet, elle fonctionne sur la base de l’échange et de la
                                    psychologie du
                                    jeune conducteur.</p>

                                <p>Il est possible de s’inscrire à un stage permis à points en ligne. Pour cela, il
                                    suffit
                                    de
                                    sélectionner le formulaire d’inscription pour le cas n°2.</p>

                                <p>Posséder la lettre 48N est nécessaire pour pouvoir s’inscrire à ce type de stage. En
                                    cas
                                    de
                                    perte de la lettre 48N, le jeune conducteur doit alors contacter sa Préfecture afin
                                    de
                                    demander son Relevé Intégral d’Information.</p>

                                <p>A partir de la réception de la lettre 48N, le conducteur dispose d’un délai de 4 mois
                                    pour
                                    procéder à son inscription au stage. Un non-respect de ce délai entraîne une
                                    contravention
                                    de classe 4 qui consiste en une suspension du permis de conduire ainsi qu’une amende
                                    de
                                    135
                                    euros.</p>

                                <p>Attention, en cas de participation du conducteur à un stage volontaire en période
                                    probatoire
                                    alors qu’il a reçu la lettre 48N :</p>

                                <ul>
                                    <li>Il sera obligé de suivre à nouveau un stage obligatoire</li>
                                    <li>Le stage volontaire lui aura bien permis de récupérer ses 4 points mais il ne
                                        pourra pas obtenir le remboursement de l’amende
                                    </li>
                                    <li>Si ces deux stages ne sont pas espacés d’au moins 1 an et 1 jour, son stage
                                        obligatoire ne lui permettra pas de récupérer ses points.
                                    </li>
                                </ul>

                                <p>Pendant la période probatoire, la récupération volontaire de points n’est possible
                                    que si le conducteur a perdu 1 ou 2 points en commettant plusieurs infractions
                                    routières. Suivre un stage volontaire après une perte de points peut éviter que
                                    votre permis de conduire soit invalidé.</p>
                            </div>

                            <div class="mb-2">

                                <h2>Récupérer ses points sur le permis probatoire à la suite du stage</h2>

                                <p>En suivant un stage obligatoire pendant sa période probatoire, le jeune conducteur
                                    peut
                                    récupérer jusqu’à 4 points.</p>

                                <p>Une fois le stage terminé, chaque participant reçoit une attestation de stage qui lui
                                    est remise par l’organisateur. Ce document permet d’attester de la récupération
                                    effective des 4 points dès le jour suivant le stage.</p>

                                <p>Ainsi, prenons l’exemple d’un jeune conducteur possédant un permis probatoire ayant
                                    un
                                    solde de 6 points et qui commet une infraction sanctionnée par une perte de 3
                                    points.
                                    S’il suit un stage obligatoire les 5 et 6 août 2019, il récupère ses 3 points dès le
                                    7
                                    août 2019. Cependant, le solde de points de son permis sera bloqué à 6 points
                                    jusqu’au
                                    terme de sa période probatoire.</p>

                            </div>

                            <div class="mb-2">

                                <h2>Se faire rembourser de l’amende après le stage obligatoire en permis probatoire</h2>

                                <p>Une fois le stage terminé, le jeune conducteur reçoit une attestation de stage. Il
                                    peut
                                    ensuite demander le remboursement de l’amende sur papier libre, adressée au Trésor
                                    Public du lieu de commission de l’amende.</p>
                                <p>Vous disposez de 15 jours pour envoyer la demande de remboursement de l’amende au
                                    Trésor
                                    Public du lieu de l’infraction.</p>
                                <p>La demande de remboursement de l’amende doit être accompagnée des documents suivants
                                    :</p>

                                <ul>
                                    <li>La photocopie de la lettre 48N</li>
                                    <li>La photocopie de l’attestation de stage
                                    <li>L’original de l’avis de contravention en question
                                    <li>La preuve que l’amende a bien été payée.</li>

                                </ul>

                            </div>
                        </v-card-text>
                    </v-card>

                </v-flex>
                <v-flex xs12 sm12 md3>
                    <v-card class="mx-2">
                        <v-card-text>
                            <RightAsideInfractions></RightAsideInfractions>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <Footer/>
    </div>
</template>

<script>
    import RightAsideInfractions from '@/components/RightAsideInfractions'
    import Footer from '@/components/Footer'

    export default {
        name: "stage-recuperation-points",
        components: {
            RightAsideInfractions,
            Footer
        }
    }
</script>

<style>
    .highlighted {
        background: #ffedf5;
        border-radius: 10px;
        color: #7a0439;
        font-size: 18px;
        font-weight: 800;
        padding: 10px;
    }

    .highlighted p {
        font-size: 18px;
    }

    ul li {
        list-style-type: circle;
        margin: 10px 0 10px 0;
    }

    a {
        text-decoration: none;
    }

    a:hover {
        color: black;
    }

    p {
        font-size: 16px;
    }
</style>
